import lapdev from '../../lapdev';

export function registration(data) {
  return lapdev.post('auth/signup', data);
}
